import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ErrorLoadingDataProps} from './types';

const {title} = translations['pt-br'].privateFlow.profile.changeData.infoAlertError;
const {tryAgain, pleaseTryAgain} = translations['pt-br'].commons;

const ErrorLoadingData = ({
	resetErrorBoundary,
	alternativeDescription,
	alternativeTitle,
}: ErrorLoadingDataProps) => (
	<Stack alignItems="center" spacing={2} mb={3}>
		<IconIllustration variant="info" />
		<Typography variant="h6" color="text.primary" textAlign="center">
			{alternativeTitle || title}
		</Typography>
		<Typography variant="body1" color="text.primary" textAlign="center">
			{alternativeDescription || pleaseTryAgain}
		</Typography>
		<Button
			onClick={resetErrorBoundary}
			size="large"
			endIcon={<Icon name="reload" />}
			variant="outlined">
			{tryAgain}
		</Button>
	</Stack>
);

export {ErrorLoadingData};
